import { fetchZipCode, validateZipCodeStructure } from '@/api/address';

export async function validateZipCode(zipCode: string) {
  if (zipCode.length === 0) {
    return true;
  }

  const isValidStructure = validateZipCodeStructure(zipCode);
  if (!isValidStructure) {
    return false;
  }

  try {
    const data = await fetchZipCode(zipCode);

    return !data!.erro;
  } catch {
    return false;
  }
}
